import React, { Component } from 'react';
import './Common.css';
import './UsernameInput.css';

class UsernameInput extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        if(this.props.hasOwnProperty("onChange")) {
            this.props.onChange(event);
        }
    }

    render() {  
        let disabled = this.props.disabled ? this.props.disabled : false;

        return (
            <div>
                <input page={this.props.page ? this.props.page : ""} disabled={disabled} autoComplete="off" placeholder="Twitter username" type="text" className={"twitterUsernameTextbox " + this.props.className + (disabled ? " twitterUsernameDisabled" : "")} name={this.props.name} value={this.props.value} onChange={this.handleChange} />
            </div>
        );
    }
  }
  
  export default UsernameInput;


// WEBPACK FOOTER //
// ./src/components/UsernameInput.js